import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Ensure the CSS is applied to the entire application
const rootElement = document.getElementById('root');
rootElement.className = 'bg-background text-foreground';
render(<App data-id="element-1684" />, rootElement);